import React from 'react';
import { Link } from 'react-router-dom';

export interface SimpleBlogEntryProps {
    imageUrl: string;
    imageAlt?: string;
    category: string;
    date: string;
    title: string;
    authorName?: string;
    linkTo?: string;
    id: number;
    /** Optional selection handler. When provided, clicking the entry triggers selection instead of navigation. */
    onSelect?: () => void;
}

function SimpleBlogEntry({
    imageUrl,
    imageAlt = '',
    category,
    date,
    title, 
    authorName,   
    linkTo = '/blog-details',
    onSelect
}: SimpleBlogEntryProps) {
    const isExternal = linkTo.startsWith('http://') || linkTo.startsWith('https://');

    const handleClick = (e: React.MouseEvent) => {
        if (onSelect) {
            e.preventDefault();
            e.stopPropagation();
            onSelect();
        }
    };

    const image = <img src={imageUrl} alt={imageAlt} className="img-fluid" />;
    const titleContent = <>{title}</>;

    return (
        <div
            className={`post-entry ${onSelect ? 'post-entry-selectable' : ''}`}
            onClick={onSelect ? handleClick : undefined}
            role={onSelect ? 'button' : undefined}
            tabIndex={onSelect ? 0 : undefined}
            onKeyDown={onSelect
                ? (e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onSelect(); } }
                : undefined
            }
        >
            {onSelect ? (
                <>
                    <div className="post-img">{image}</div>
                    <div className="post-meta">
                        {authorName && <div>
                            <img className='pe-1' src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABF0lEQVR4nO3TMUoDURSF4U80gi7BWFioKxArWzsrEWxj6Q7sHEuXIiGp1ErcgOkE0UJEsFEUTAQtIwO3eAkzkuik88Ap5r65/3nvvhn+VZEW0UQv3MJKlfA39Iec1+pVBDQDeIVGuBO1kyoCegHLwVvhRtTeqwjoTjqgFbBOwYjy8f1Zq3gtueRlFakeF9oNN6uE/6tU09jEMS5wgw984hHnOMQ6poyhORzgpeDLKfMdNhJGHnyLpWH4Aq6Txie0o2EfO9jGHo5whud4pxaMWjzn/ffDAaex8IAs+XN/cj6imejPAj6fbGxAXxGwOyJ8LZl/lpw8PdGA+mP4ErMF8H7RzscNaCc7HBn+G2WThOeaKDwNKIV/A2iugkOw0BtAAAAAAElFTkSuQmCC" alt="writer-male"></img>                            
                            <span className="author">{authorName}</span>
                        
                        </div>}
                        <img className='pe-1'src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAhklEQVR4nO2RQQqAIBREHy26Tldx643qhOkBqmMYgkEEWiMuWvhgFh90RudDR2QEFmAHgqgNmJNHlrnCODwUPbLUvDw8dJQCQiNlsY30vwAPOGGWAxywCvP/KrKtA9TOvboDtXPXd+Bf5s8BprJze1P0yDI1qGcqBQzpwPUTK8iku9Gjw2dOggetgk0jgd8AAAAASUVORK5CYII=" alt="calendar--v1"></img>
                        <span className="date">{date}</span>
                        <br />
                        <span className="tags">{category.split(',').map((item) => <span key={item} className="badge bg-primary me-1">{item}</span>)}</span> 
                    </div>
                    <h3>{titleContent}</h3>
                    <hr ></hr>
                </>
            ) : (
                <>
                    {isExternal ? (
                        <a href={linkTo} target="_blank" rel="noopener noreferrer">
                            {image}
                        </a>
                    ) : (
                        <Link to={linkTo}>{image}</Link>
                    )}
                    <div className="post-meta">                        
                        
                        <span className="date">{category}</span> <span className="mx-1">•</span> <span>{date}</span>
                    </div>
                    <h2>
                        {isExternal ? (
                            <a href={linkTo} target="_blank" rel="noopener noreferrer">{title}</a>
                        ) : (
                            <Link to={linkTo}>{title}</Link>
                        )}
                    </h2>
                </>
            )}
        </div>
    );
}

export default SimpleBlogEntry;

